import ModBadge from "../../components/common/ModBadge";
import { fmt, fmtDate } from "../../services/formatting";
import {
  sanitizeNonNegativeInput,
  sanitizePositiveIntegerInput,
} from "../../utils/nonNegativeInput";
import { getKnownPlatforms } from "../../services/platformCatalog";
import { sortTournamentsByName } from "../../services/tournamentSorting";

export default function RegistroInlineEditRow({
  registro,
  index,
  form,
  errors,
  tournaments,
  getTournament,
  onChange,
  onSave,
  onCancel,
}) {
  const platformOptions = getKnownPlatforms(tournaments, form.plataforma);
  const filteredTournaments = form.plataforma
    ? tournaments.filter((tournament) => tournament.plataforma === form.plataforma)
    : tournaments;
  const selectedTournament = getTournament(form.torneioId);
  const inscricoes = Number(form.inscricoes || 1);
  const buyin = selectedTournament ? Number(selectedTournament.buyin) : 0;
  const isSatTournament = selectedTournament?.modalidade === "SAT";

  const handleChange = (field, value) => {
    onChange({ ...form, [field]: value });
  };

  const handlePlatformChange = (platform) => {
    const selectedStillMatches =
      !form.torneioId ||
      !platform ||
      getTournament(form.torneioId)?.plataforma === platform;

    onChange({
      ...form,
      plataforma: platform,
      torneioId: selectedStillMatches ? form.torneioId : "",
    });
  };

  const handleTournamentChange = (tournamentId) => {
    const tournament = getTournament(tournamentId);
    onChange({
      ...form,
      torneioId: tournamentId,
      plataforma: tournament?.plataforma || form.plataforma,
    });
  };

  return (
    <div>
      {index > 0 && <hr className="divider" />}
      <div
        className={`tr registros-table__row registros-table__row--editing motion-list-row motion-list-row--${Math.min(index, 8)}`}
      >
        <div className="registros-table__edit-field">
          <select
            className="input-field registros-table__edit-control"
            value={form.plataforma}
            onChange={(event) => handlePlatformChange(event.target.value)}
          >
            <option value="">Plataforma</option>
            {platformOptions.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </select>
          {errors.plataforma && (
            <span className="registros-table__edit-error">{errors.plataforma}</span>
          )}
        </div>

        <div className="registros-table__edit-field">
          <select
            className="input-field registros-table__edit-control"
            value={form.torneioId}
            onChange={(event) => handleTournamentChange(event.target.value)}
          >
            <option value="">Selecione...</option>
            {sortTournamentsByName(filteredTournaments)
              .map((tournament) => (
                <option key={tournament.id} value={tournament.id}>
                  {tournament.nome} - {fmt(tournament.buyin, tournament.buyinCurrency)}
                  {tournament.source === "common" && tournament.plataforma
                    ? ` · ${tournament.plataforma}`
                    : ""}
                </option>
              ))}
          </select>
          {errors.torneioId && (
            <span className="registros-table__edit-error">{errors.torneioId}</span>
          )}
        </div>

        <div className="registros-table__edit-buyin">
          <div className="registros-table__buyin">
            {fmt(buyin, selectedTournament?.buyinCurrency)}
            {inscricoes > 1 && (
              <span className="registros-table__buyin-count">x{inscricoes}</span>
            )}
          </div>
          {!isSatTournament && (
            <label className="registros-table__edit-ticket">
              <input
                type="checkbox"
                checked={form.isSatellite}
                onChange={(event) =>
                  handleChange("isSatellite", event.target.checked)
                }
              />
              Ticket
            </label>
          )}
        </div>

        <div>
          {selectedTournament ? (
            <ModBadge mod={selectedTournament.modalidade || "Vanilla"} />
          ) : (
            "-"
          )}
        </div>

        <div className="registros-table__edit-field">
          <input
            className="input-field registros-table__edit-control registros-table__edit-control--number"
            type="number"
            min="1"
            value={form.inscricoes}
            onChange={(event) =>
              handleChange(
                "inscricoes",
                sanitizePositiveIntegerInput(event.target.value, 3)
              )
            }
          />
          {errors.inscricoes && (
            <span className="registros-table__edit-error">{errors.inscricoes}</span>
          )}
        </div>

        <div className="registros-table__edit-field">
          {isSatTournament ? (
            <input
              className="input-field registros-table__edit-control"
              type="number"
              min="0"
              placeholder="Tickets"
              value={form.tickets}
              onChange={(event) =>
                handleChange("tickets", sanitizeNonNegativeInput(event.target.value, 3))
              }
            />
          ) : (
            <input
              className="input-field registros-table__edit-control"
              type="number"
              min="0"
              placeholder="Premiacao"
              value={form.premiacao}
              onChange={(event) =>
                handleChange("premiacao", sanitizeNonNegativeInput(event.target.value, 9))
              }
            />
          )}
          {(errors.premiacao || errors.tickets) && (
            <span className="registros-table__edit-error">
              {errors.premiacao || errors.tickets}
            </span>
          )}
        </div>

        <div className="registros-table__date">
          {fmtDate(registro.registradoEm)}
        </div>

        <div className="registros-table__actions registros-table__actions--editing">
          <button className="btn-icon btn-edit" title="Salvar" onClick={onSave}>
            OK
          </button>
          <button className="btn-icon btn-del" title="Cancelar" onClick={onCancel}>
            X
          </button>
        </div>
      </div>
    </div>
  );
}
